import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { css } from "../../../../styled-system/css";
import Header from "../../../components/header";
import {
  HOKKAIDO_HOUSEHOLDER_CAMPAIGN_END_DATE,
  HOKKAIDO_HOUSEHOLDER_CAMPAIGN_START_DATE,
} from "../../../config";
import {
  HokkaidoR8HouseholderCodeModal,
  WalletCard,
  getBalanceInfo,
} from "../../../features/home";
import { getCurrentTime } from "../../../libs/date";
import { AppError, ERROR_CODES } from "../../../libs/errors";
import { t } from "../../../libs/i18n";

export const Route = createFileRoute("/_authed/hkp/$code")({
  loader: async ({ context: { client, tenant } }) => {
    if (tenant.slug !== "hokkaido") {
      throw redirect({
        to: "/",
        state: {
          toast: {
            message: t("北海道ポイント以外でこのQRコードは開けません"),
            type: "error",
          },
        },
      });
    }
    const currentTime = await getCurrentTime();
    if (currentTime.date < HOKKAIDO_HOUSEHOLDER_CAMPAIGN_START_DATE) {
      throw redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }
    if (currentTime.date > HOKKAIDO_HOUSEHOLDER_CAMPAIGN_END_DATE) {
      throw redirect({
        to: "/",
        state: {
          toast: {
            message: t("どうみんポイント給付事業は終了しました"),
            type: "error",
          },
        },
      });
    }
    const balance = await client.getMyBalances({}).catch((error) => {
      throw new AppError(
        ERROR_CODES.CONNECT_GET_MY_BALANCES_FAILED,
        error.message,
        { originalError: error },
      );
    });
    const { totalAmount, nearestExpireAtDate } = getBalanceInfo(balance);
    return { tenant, totalAmount, nearestExpireAtDate };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { code } = Route.useParams();
  const { totalAmount, nearestExpireAtDate } = Route.useLoaderData();
  const { client, tenant } = Route.useRouteContext();
  const navigate = useNavigate();

  const handleGoHome = useCallback(() => {
    navigate({ to: "/" });
  }, [navigate]);

  return (
    <>
      <Header title={t("ホーム")} onClickBack={handleGoHome} />
      <div
        className={css({
          pt: "24px",
          px: "20px",
          pb: "64px",
          display: "flex",
          flexDir: "column",
          gap: "16px",
        })}
      >
        <WalletCard
          tenant={tenant}
          totalAmount={totalAmount}
          nearestExpireAtDate={nearestExpireAtDate}
        />
      </div>
      <HokkaidoR8HouseholderCodeModal
        code={code}
        client={client}
        onClose={handleGoHome}
      />
    </>
  );
}
